<template>
  <div id="app"
       :class="$i18n.locale=='en-US'?'english':''">
    <router-view></router-view>
    <dialog-component :visible="isShowBusinessDialog"
                      :name="$t(`m.提示`)"
                      @cancel="isShowBusinessDialog=false"
                      :show-button="false">
      <div style="text-align: center;max-width: 360px">
        <p style="text-align: left"
           v-if="agentMap&&agentMap.businessDialogMsg">{{agentMap.businessDialogMsg}}</p>
        <p v-else
           style="text-align: left">{{businessDialogMsg}}
          <span style="color: #ff5630">{{businessDialogWarnMsg}}</span>
        </p>
        <template v-if="type==='business'">
          <img v-if="agentMap&&agentMap.callUs&&agentMap.callUs.pic"
               :src="agentMap.callUs.pic"
               style="width: 250px">
          <img v-else
               src="./assets/cuihua.png"
               style="width: 250px">
          <div style="line-height: 24px;font-size:14px;">
            <div v-if="agentMap&&agentMap.phone">{{$t(`m.周老师`)}} ：{{agentMap.phone}}（{{$t(`m.微信手机同号`)}}）</div>
            <div v-else>
              商务：18501331225<br />
            </div>
            <!-- <div v-else>{{$t(`m.商务合作`)}} Tel：18501331225（{{$t(`m.微信同号`)}}）</div> -->
          </div>
        </template>
        <template v-else-if="type==='operate'">
          <img src="./assets/cuihua.png"
               style="width: 250px">
          <div>
            商务：18501331225<br />
          </div>
          <!-- <div style="line-height: 24px;font-size:14px;">
            <div>{{$t(`m.运营`)}} Tel：18501331225（{{$t(`m.微信同号`)}}）
            </div>
          </div> -->
        </template>
      </div>
    </dialog-component>
  </div>
</template>

<script>
import dialogComponent from './components/dialogNew';

export default {
  name: 'App',
  components: {
    dialogComponent,
  },
  data() {
    return {
      isShowBusinessDialog: false,
      businessDialogMsg: '',
      businessDialogWarnMsg: '',
      type: 'business', //'operate'
      agentMap: null,
    };
  },
  created() {
    let agentAccess = this.$agentMap.get(location.host);

    this.agentMap = agentAccess;
    this.$httpService.setEventByName('showBusiness', (data, type = 'business') => {
      if (typeof data === 'string') {
        this.businessDialogMsg = data;
        this.businessDialogWarnMsg = '';
      } else if (typeof data === 'object') {
        this.businessDialogWarnMsg = data.warn;
        this.businessDialogMsg = data.msg;
      }
      this.isShowBusinessDialog = true;
      this.type = type;
    });
    if (agentAccess) {
      // window.title
      document.title = agentAccess.title;
      var linkEle = document.getElementById('link1');
      linkEle.href = agentAccess.logo;
      linkEle.type = '';
      linkEle.type = 'image/x-icon';
    } else {
      document.title = this.$t(`m.第四范式智能客服平台`);
    }
  },
  destroyed() {
    this.$httpService.clearEventByName('showBusiness');
  },
};
</script>

<style lang="less">
@import 'element-ui';
@import 'ue';
@import 'operate';
@import 'english';

#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  /*text-align: center;*/
  color: @main-text-black;
  height: 100%;
}

* {
  padding: 0;
  margin: 0;
}

a {
  text-decoration: none;
  cursor: pointer;
  outline: 0 none !important;
}

.clearfix:after {
  content: '.';
  display: block;
  height: 0;
  clear: both;
  visibility: hidden;
}

img {
  vertical-align: middle;
}

li {
  list-style: none;
}

html,
body {
  height: 100%;
  background-color: @back-grey;
}

/*统一字体大小设置*/
body {
  font-size: 12px;
}

h1 {
  font-size: 20px;
}

h2 {
  font-size: 16px;
}

h3 {
  font-size: 12px;
}

/*设置统一字体*/
body {
  font-family: PingFang SC, STHeitiSC-Light, Microsoft Yahei, Helvetica Neue, Helvetica, Arial, sans-serif;
}

button {
  outline: none;
  cursor: pointer;
  border: none;
}

textarea {
  resize: none !important;
}

/*button统一样式*/
button {
  font-size: 14px;
}

.blueBtn {
  height: 36px;
  line-height: 36px;
  background: @text-blue;
  color: @white;
  padding: 0px 32px;

  &:hover {
    background: @hover-blue;

    a {
      text-decoration: underline;
    }
  }

  &.active {
    background: @text-blue;
    box-shadow: inset 0 1px 3px 0 rgba(0, 0, 0, 0.5);
  }

  &[disabled] {
    background: #abd2f7;
    cursor: not-allowed;
  }
}

.ics-new-user-circular {
  position: absolute;
  width: 90px;
  height: 90px;
  background-image: radial-gradient(circle at 50% 49%, rgba(140, 195, 245, 0), rgba(181, 216, 248, 0.36));
  border: solid 2px rgba(230, 234, 238, 0.74);
  border-radius: 100%;
}

.bottomLine {
  width: 100%;
  height: 1px;
  margin-bottom: 18px;
  background-color: @border-grey;
}

.whiteBtn {
  height: 36px;
  line-height: 34px;
  background: @white;
  border: 1px solid #dfe2e5;
  color: @main-text-black;
  padding: 0px 20px;

  &:hover {
    border: 1px solid @text-blue;
    color: @text-blue;

    a {
      text-decoration: underline;
    }
  }

  &[disabled] {
    background: @disable-white;
    border: 1px solid @input-gray;
    color: @sub-text-gray;
    cursor: not-allowed;
  }
}

.whiteBtnSmall {
  height: 24px;
  line-height: 22px;
  background: @white;
  border: 1px solid @input-gray;
  padding: 0px 6px;
  color: @main-text-black;

  &[disabled] {
    background: @disable-white;
    border: 1px solid @input-gray;
    color: @sub-text-gray;
    cursor: not-allowed;
  }

  img {
    margin-top: -3px;
  }
}

.whiteBtnInner {
  height: 30px;
  line-height: 30px;
  background: @white;
  padding: 0px 12px;
  border: 1px solid @input-gray;
  color: @main-text-black;

  &[disabled] {
    background: @disable-white;
    border: 1px solid @input-gray;
    color: @sub-text-gray;
    cursor: not-allowed;
  }
}

input {
  outline: none;
  padding-left: 5px;
  border: 1px solid @border-grey;
}

.searchInput {
  background: white url('./assets/search-icon.svg') 5% center no-repeat;
  width: 260px;
  padding-left: 36px;
  /*line-height: 24px;*/
  height: 24px;
}

input::-moz-placeholder {
  color: #9fa7b1;
}

input::-webkit-input-placeholder {
  color: #9fa7b1;
}

input:-ms-input-placeholder {
  color: #9fa7b1;
}

.listTable {
  width: 100%;
  background-color: white;
  border: 1px solid @border-grey;
  border-collapse: collapse;
  font-size: 14px;

  td {
    padding: 15px 18px;
    word-break: break-all;
  }

  thead {
    color: #828ca0;
  }

  tbody > tr {
    border-top: 1px solid @border-grey;

    &:hover,
    &.active {
      background: @back-grey;
    }
  }
}

/*返回样式*/
.back {
  padding: 0px 1px;
  cursor: pointer;
  width: 50px;
  line-height: 30px;

  span {
    font-size: 14px;
    font-weight: 700;
    margin-right: 5px;
    color: @icon-gray;
  }

  &:hover {
    color: #000;
  }
}

.url {
  padding: 10px 18px 9px 18px;
  word-break: break-all;
  background-color: #f5f7fa;
  color: #354052;
  display: inline-block;
  font-size: 12px;
}

/*确认 取消样式*/
.btton-list {
  margin-top: 13px;
  text-align: right;

  button {
    padding: 0 36px;
    margin-right: 12px;

    &:last-of-type {
      margin-right: 0px;
    }
  }
}

/*下拉列表样式*/
.spe-list {
  position: absolute;
  border: 1px solid @border-grey;
  background: @white;
  z-index: 100;

  li {
    text-align: center;
    height: 36px;
    line-height: 36px;
    border-bottom: 1px solid @border-grey;
    cursor: pointer;

    &:hover {
      color: @text-blue;

      a {
        color: @text-blue;
      }
    }

    a {
      display: inline-block;
      /*width: 135px;*/
      height: 36px;
      color: @main-text-black;
    }
  }

  li:last-of-type {
    border: none;
  }
}

/*语音背景样式*/
.play-back {
  height: 60px;
  width: 90px;
  background: @text-blue;
  /*float: left;*/
  display: inline-block;
  position: relative;
  vertical-align: middle;

  button {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: inline-block;
    height: 12px;
    width: 12px;
    cursor: pointer;
    border: none;
  }

  .i-pause {
    background: url('../src/assets/images/i-pause.svg');
  }

  .i-play {
    background: url('../src/assets/images/i-play.svg');
  }
}

/*文字..*/
.ellipse {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

/*span蓝色可点击字体*/
.span-blue {
  cursor: pointer;
  color: @text-blue;
}

.span-red {
  color: @w-c1;
}

/*无内容*/
.no-rule {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  text-align: center;
}

/*搜索任务*/
.time {
  font-size: 0;
  border: 1px solid @border-grey;
  height: 42px;
  line-height: 42px;
  background: @white;
  justify-content: space-between;
  margin: 12px 0px;

  .whiteBtn {
    padding: 0px 12px;
    float: left;
    height: 42px;
    border: none;
    border-right: 1px solid @border-grey;
  }
}

.pre-wrap {
  white-space: pre-wrap;
  word-break: break-all;
}

/**IE**/
::-ms-clear,
::-ms-reveal {
  display: none;
}

/**清除浮动**/
.clearfix:after {
  content: '';
  display: block;
  visibility: hidden;
  clear: both;
  height: 0;
}

.clearfix {
  /* 为了照顾ie6浏览器*/
  zoom: 1;
}

.z-flex {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  align-items: flex-start;

  .f-right {
    flex: 1;
  }
}

.z-line {
  height: 1px;
  width: 100%;
  margin: 18px auto;
  background: @border-grey;
}

.z-float-left {
  float: left;
}

.title-notice {
  margin: 18px 0;
  padding: 8px;
  border: 1px solid @diff-yellow;
  background-color: @light-yellow;
  font-size: 12px;

  .el-icon-info {
    color: @diff-yellow;
    margin-right: 5px;
  }

  a {
    color: @blue;
  }
}

//？点击查看视频
.vedio-tol {
  color: @text-blue !important;
}
</style>



// WEBPACK FOOTER //
// src/App.vue